/**
 * This is the collection of all zindexes of within ux-twoui.
 * The complete collection is in core-utilities, when every you
 * need to make some changes, please coordinate with zindexes.ts in
 * core-utilities first.
 * Please increase 1 at a time if you need something higher.
 * Please sort then in ascending order.
 * Please prefix with vertical name, ie:
 *      suiteHeaderEntireSuiteHeader
 *      twoUINotificationBar
 *      profileSomethingElse
 */

export const twouiZIndexes = {
    bingMapsOverlay: 1,
    twoUIFlowProgressBar: 1,
    twoUITab: 1,
    bingMapsListContainer: 2,
    bingMapsNoPushPinContainer: 3,
    twoUINavBar: 5, // footer "viewas" red banner is linked to suiteHeaderWholeHeader
    twoUILiveToast: 6,
    twoUINavBarOverHeader: 11,
    twoUILeftNavBypassBlocksButton: 10000,
    twoUIPanel: 10001,
    twoUINotificationBar: 10002,
} as const;
